"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _auth = require("./auth");
Object.keys(_auth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _auth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _auth[key];
    }
  });
});
var _registration = require("./registration");
Object.keys(_registration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _registration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _registration[key];
    }
  });
});
var _socialAuth = require("./socialAuth");
Object.keys(_socialAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _socialAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _socialAuth[key];
    }
  });
});
var _twoFactor = require("./twoFactor");
Object.keys(_twoFactor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _twoFactor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _twoFactor[key];
    }
  });
});
var _mrOAuth = require("./mrOAuth");
Object.keys(_mrOAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mrOAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mrOAuth[key];
    }
  });
});
var _phoneAuth = require("./phoneAuth");
Object.keys(_phoneAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _phoneAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _phoneAuth[key];
    }
  });
});
var _rememberedAccounts = require("./rememberedAccounts");
Object.keys(_rememberedAccounts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _rememberedAccounts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _rememberedAccounts[key];
    }
  });
});
var _getCianAnalyticsObjectPage = require("./getCianAnalyticsObjectPage");
Object.keys(_getCianAnalyticsObjectPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCianAnalyticsObjectPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCianAnalyticsObjectPage[key];
    }
  });
});